import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { BaseNotification } from './Base.js';
const StyledNotification = styled(BaseNotification) `
  width: 100%;
  padding: 12px 16px;
  gap: 12px;
  border-radius: 0;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  border-top: none;
  border-left: none;
  border-right: none;
`;
export const AppBarNotification = (props) => _jsx(StyledNotification, { ...props, closeable: true, role: 'alert' });
